import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  brick: {
    borderRadius: '4px',
    position: 'relative',
    overflow: 'hidden',

    '&.animated': {
      background: 'var(--overlay-skeleton)',

      '&:before': {
        content: '""',
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1,
        animation: 'brick-run 1.2s infinite',

        'body[theme="dark"] &': {
          background:
            'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%)',
        },

        'body[theme="light"] &': {
          background:
            'linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0) 100%)',
        },
      },
    },

    '&:not(.animated)': {
      backgroundColor: 'var(--text-disabled)',
    },
  },

  '@global': {
    '@keyframes brick-run': {
      '0%': {
        transform: 'translateX(-100%)',
      },
      '100%': {
        transform: 'translateX(100%)',
      },
    },
  },
}));

export default useStyles;
